import { render, staticRenderFns } from "./AccountNoticesAlert.vue?vue&type=template&id=269ce998&"
import script from "./AccountNoticesAlert.vue?vue&type=script&lang=ts&"
export * from "./AccountNoticesAlert.vue?vue&type=script&lang=ts&"
import style0 from "./AccountNoticesAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VContainer})
